import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/ui/error/jpg-png/404-mobile.png")